// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__g-0M2","delete":"styles_delete__31_uY","update":"styles_update__3OQQB","add":"styles_add__1U_75"};